{
  "stepper": {
    "title": "Progresul fluxului",
    "discardReason": "Motiv: {{comment}}",
    "readyToScheduleVisit": "Gata pentru programarea unei vizionări",
    "dateLabel": "Data:",
    "addressLabel": "Adresă:",
    "commentLabel": "Comentariu:"
  },
  "commentForm": {
    "defaultTitle": "Adaugă comentariu",
    "commentLabel": "Comentariu",
    "commentPlaceholder": "Introduceți comentariul aici...",
    "commentRequired": "Comentariul este obligatoriu",
    "submit": "Trimite"
  },
  "visitSchedule": {
    "title": "Programează vizionare",
    "dateLabel": "Data și ora vizionării",
    "addressLabel": "Adresa vizionării",
    "addressPlaceholder": "Introduceți adresa completă pentru vizionare",
    "dateRequired": "Data vizionării este obligatorie",
    "dateInFuture": "Data vizionării trebuie să fie în viitor",
    "addressRequired": "Adresa vizionării este obligatorie",
    "submit": "Programează"
  }
}
